import React, { useEffect, useState } from "react";
//mui components
import {
  Grid,
  Box,
  Typography,
  Button,
  Tab,

} from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
// icons
import {
  Dashboard,
} from "@mui/icons-material";

import ArrowBackButton from "../../../Base/views/ArrowBackButton";
import Popup from "../../../Base/views/Popup";
import ConfirmationDialog from "../../../Base/views/ConfirmationDialog";

import { DeletePerformanceLogAction, GetPerformanceLogAction } from "../../../../../store/Employee/PMSystem/Action";
import { useDispatch, useSelector } from "react-redux";
import PerformanceCard, { CheckinCardSkeleton } from "./PerformanceCard";
import LogCheckIn from "./LogCheckInPopup";
import { getUserId, isAdminOwner } from "../../../Base/helper/baseFunctions";
import history from "../../../../../history";

export default function ContinuousPerformance() {

  const [createpopup, setcreatepopup] = useState(false);
  const [value, setValue] = useState("1");
  
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  
  
  const dispatch = useDispatch();
  const [currentPerformanceLog, setCurrentPerformanceLog] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [popupMode, setPopupMode] = useState("");
    const { logLoading, performanceLogData } = useSelector(
      (state) => state?.EmployeeReducer?.ManageGoalReducer || {}
    );   
    const closeMode = () => {
      setcreatepopup(false);
      setCurrentPerformanceLog(null);
      setOpenDialog(false);
       setPopupMode("");
    };
  const handleLogPopup = (currentData, actionType) => {
    if(actionType === "Edit" || actionType === "Preview"){
      setcreatepopup(true);
      setPopupMode(actionType);
    }
    if(actionType === "Delete"){
      setOpenDialog(true);
    }
    setCurrentPerformanceLog(currentData);
  }
    const handleDeleteLog = () => {
      dispatch(DeletePerformanceLogAction({checkin_pk: currentPerformanceLog?.checkin_pk}))
      setOpenDialog(false);
      closeMode();
    }
  useEffect(() => {
    dispatch(GetPerformanceLogAction({user_id: value === "1" ? getUserId() : "null"}));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[value])
  return (
    <Box sx={{ maxHeight: "87vh", overflowY: "auto" }}>
      <Box
        sx={{
          position: "sticky",
          background: "#fff",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <ArrowBackButton
          iconSize={18}
          onClick={() => {
            history.goBack();
          }}
        />
        <Typography
          sx={{
            fontFamily: "Nunito Sans",
            fontWeight: 700,
            color: "#000000",
            fontSize: "1.2rem",
          }}
        >
          Continuous Performance
        </Typography>
        <Dashboard fontSize="small" />
      </Box>
      <Box>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList
              onChange={handleChange}
              aria-label="lab API tabs example"
              sx={{ display: "flex", justifyContent: "space-between" }}
            >
              <Tab
                label={
                  <div>
                    {/* <BookmarkBorder style={{ verticalAlign: "middle" }} />  */}
                    My Check-In
                  </div>
                }
                value="1"
              />
              {isAdminOwner() && ( <Tab
                label={
                  <div>
                    {/* <BackupOutlined style={{ verticalAlign: "middle" }} /> */}
                    Team Check-In
                  </div>
                }
                value="2"
              />)}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  pr: 2,
                  height: 36,
                  mt: 0.5 ,
                  width: "100%",
                }}
              >
                <Button
                  type="submit"
                  variant="contained"
                  size="small"
                  className="mpl-primary-btn"
                  onClick={() => {
                    setcreatepopup(true);
                  }}
                >
                  Log Check-In
                </Button>
              </Box>
            </TabList>
          </Box>
          <TabPanel value="1" sx={{ p: 1 }}>
            <Box sx={{ marginTop: 1}}>
              <Grid container spacing={2}>
                {logLoading ? Array.from(new Array(8)).map((_, idx) => (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={idx}>
                      <CheckinCardSkeleton />
                    </Grid>
                  ))
                : performanceLogData?.length > 0 ? (
                  performanceLogData?.map((checkin, index) => (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                      <PerformanceCard checkin={checkin}  handleCheckinPopup={handleLogPopup} value={value} />
                    </Grid>
                  ))
                ) : (
                   <Grid item xs={12}>
                     <Box
                      sx={{
                        height: "40vh",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        variant="h6"
                        color="text.secondary"
                        sx={{ textAlign: "center", px: 2 }}
                      >
                        No Data Available
                      </Typography>
                    </Box>
                  </Grid>
                )}
              </Grid>
            </Box>
          </TabPanel>
          <TabPanel value="2" sx={{ p: 1 }} >
            <Box sx={{ marginTop: 1}}>
              <Grid container spacing={2}>
                {logLoading ? Array.from(new Array(8)).map((_, idx) => (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={idx}>
                      <CheckinCardSkeleton />
                    </Grid>
                  ))
                : performanceLogData?.length > 0 ? (
                  performanceLogData?.map((checkin, index) => (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                      <PerformanceCard checkin={checkin}  handleCheckinPopup={handleLogPopup} value={value}/>
                    </Grid>
                  ))
                ) : (
                   <Grid item xs={12}>
                     <Box
                      sx={{
                        height: "40vh",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        variant="h6"
                        color="text.secondary"
                        sx={{ textAlign: "center", px: 2 }}
                      >
                        No Data Available
                      </Typography>
                    </Box>
                  </Grid>
                )}
              </Grid>
            </Box>
          </TabPanel>
        </TabContext>
      </Box>
      <Popup
        title={currentPerformanceLog ? `${popupMode} Logged Check-In` : "Log Check-In"}
        openPopup={createpopup}
        setOpenPopup={closeMode}
        fullWidth={true}
        maxWidth="sm"
      >
      <LogCheckIn
        setOpenPopup={setcreatepopup}
        closeMode={closeMode}
        currentPerformanceLog={currentPerformanceLog}
        mode={popupMode} 
      />
      </Popup>

      <ConfirmationDialog
          title={"Delete Check-In"}
          content={"Are you sure you want to proceed?"}
          openDialog={openDialog}
          closeDialog={setOpenDialog}
          OkButtonText="Yes"
          onSubmit={handleDeleteLog}
        />
    </Box>
  );
}

